import { createSlice } from "@reduxjs/toolkit";

export const configurationSlice = createSlice({
  name: "configuration",
  initialState: {
    configurations: [],
    edit_configuration_id: null,
    editingConfiguration: null,
    loading: false,
    error: null,
  },
  reducers: {
    setLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
    setConfigurations: (state, action) => {
      state.loading = false;
      state.error = null;
      state.configurations = action.payload.data;
    },
    setError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    addConfiguration: (state, action) => {
      state.configurations.push(action.payload);
    },
    setEditingConfigurationId: (state, action) => {
      state.edit_configuration_id = action.payload;
    },
    setEditingConfiguration: (state, action) => {
      const configurationId = action.payload
      const configToEdit = state.configurations.find((configuration) => configuration.id === configurationId);
      if (configToEdit) {
        state.editingConfiguration = configToEdit;
      }
    },
    updateConfiguration: (state, action) => {
      const index = state.configurations.findIndex(
        (configuration) => configuration.id === action.payload.id
      );
      if (index !== -1) {
        state.configurations[index] = action.payload;
      }
      state.edit_configuration_id = null;
    }

  },
})

export const {
  setLoading,
  setConfigurations,
  addConfiguration,
  setEditingConfigurationId,
  setError,
  setEditingConfiguration
} = configurationSlice.actions;

export default configurationSlice.reducer;